import theme from "@/theme";

export const styles = {
  root: {
    position: "relative",
    backgroundColor: theme.palette.custom.mainWhite,
    boxSizing: "border-box",
    padding: 0,
    margin: 0,
    dosplay: "flex",
    height: "100%",
    zIndex: 3000,
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    padding: 0,
    height: "100%",
    minHeight: "0px !important",
    backgroundColor: theme.palette.custom.mainWhite,
  },

  wrapper: {
    maxWidth: "1200px",
    width: "100%",
    height: "100%",
    display: "grid",
    gridTemplateColumns: "1fr auto",

    alignItems: "center",

    margin: "0 auto",
    background: "#fff",
    "@media (max-width: 450px)": {
      gridTemplateColumns: "1fr",
      gridTemplateRows: "48px 48px",
    },
  },
};
